import { useAtomValue } from 'jotai/utils'

import { gridStateAtomFamily } from './atoms/gridStateFamilyAtom'
import { useGridIdentity } from './GridIdentityProvider'

export const useCurrentGridState = () => {
  const identity = useGridIdentity()
  return useAtomValue(gridStateAtomFamily(identity))
}
